import { css } from 'styled-components';
import { breakpoints } from '../../../style-utilities/variables';
export default css`
  @media (max-width: ${breakpoints.generalDesktop}) {
    img {
      max-width: 250px;
    }
  }
`;
